import { Config } from 'types';

export const isUtilizaAssinatura = (config: Config) => {
  return config.possuiAssinaturaCortesia || config.possuiAssinaturaContratada;
};

export const isUtilizaAssinaturaDigital = (config: Config) => {
  return config.possuiAssinaturaContratada;
};
